import { FC } from 'react';

import { IconProps } from '../types';

const KosherIcon: FC<IconProps> = ({ size, ...props }) => (
  <svg
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    {...props}
    aria-hidden="true"
  >
    <path
      d="M29.4575 7.73927C30.5808 7.77097 31.7044 7.80228 32.8276 7.834C29.184 10.3241 25.5405 12.8146 21.897 15.3047L21.6812 15.4522L21.8501 15.6514C24.2618 18.5002 26.6737 21.3494 29.0854 24.1983C31.388 26.9181 33.6911 29.6376 35.9937 32.3574C33.9988 32.3625 32.0041 32.368 30.0093 32.3731C27.8818 32.3785 25.7539 32.3833 23.6265 32.3887C20.3985 28.5914 17.17 24.7943 13.9419 20.9971L13.8052 20.835L13.6294 20.9551C13.5517 21.0082 13.4738 21.0611 13.396 21.1143C13.318 21.1676 13.2396 21.2211 13.1616 21.2744L13.0591 21.3447V32.3233H3.73584V7.95412H13.0591V15.6504H13.9468L14.0073 15.6084C17.818 12.9474 21.6291 10.286 25.4399 7.62502C26.7791 7.66285 28.1183 7.70148 29.4575 7.73927Z"
      fill="#030303"
      stroke="white"
      strokeWidth="0.471446"
    />
  </svg>
);

export default KosherIcon;
